export const decodeUtm = (value) => {
    return decodeURIComponent(value.replace(/\+/g, " "));
};
